var Language;
(function (Language) {
    Language["En"] = "English";
    Language["Fr"] = "Fran\u00E7ais";
    Language["De"] = "Deutsch";
    Language["Es"] = "Espa\u00F1ol";
})(Language || (Language = {}));
var LanguageCode;
(function (LanguageCode) {
    LanguageCode["En"] = "en";
    LanguageCode["Fr"] = "fr";
    LanguageCode["De"] = "de";
    LanguageCode["Es"] = "es";
})(LanguageCode || (LanguageCode = {}));
const DEFAULT_SITE_LANGUAGE = LanguageCode.En;
const SITE_LANGUAGES = [LanguageCode.En, LanguageCode.De, LanguageCode.Fr, LanguageCode.Es];
const LANGUAGE_OPTIONS = [
    { value: LanguageCode.En, label: Language.En },
    { value: LanguageCode.Fr, label: Language.Fr },
    { value: LanguageCode.De, label: Language.De },
    { value: LanguageCode.Es, label: Language.Es },
];

export { DEFAULT_SITE_LANGUAGE as D, Language as L, SITE_LANGUAGES as S, LanguageCode as a, LANGUAGE_OPTIONS as b };
//# sourceMappingURL=language-BHHwgtQp.js.map
